import { TextMaterialTheme } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import { gql, useQuery } from '@apollo/client'
import { SHORTCUT_TEXT_MATERIAL_THEME_FIELDS } from '../textMaterialShortcut'


export interface SingleTextMaterialTheme {
  singleTextMaterialTheme: TextMaterialTheme
}

export interface SingleTextMaterialThemeVariables {
  id?: GQL_ID
}

export const GQL_QUERY_SINGLE_TEXT_MATERIAL_THEME = gql`
  query ($id: ID!) {
    singleTextMaterialTheme(id: $id) {
      ${SHORTCUT_TEXT_MATERIAL_THEME_FIELDS}
    }
  }
`


export const useFetchSingleTextMaterialTheme = (variables: SingleTextMaterialThemeVariables) =>
  useQuery<SingleTextMaterialTheme, SingleTextMaterialThemeVariables>(
    GQL_QUERY_SINGLE_TEXT_MATERIAL_THEME,
    {
      variables,
      fetchPolicy: 'cache-and-network',
      skip: !variables.id
    }
  )